const sshSessions = {
  state: () => ({
    sessions: [],
    activeSessionId: null,
    isVisible: false,
    panelState: {
      height: 440,
      isMinimized: false,
      isFullscreen: false
    }
  }),

  getters: {
    sshSessions: state => state.sessions,
    activeSshSession: state => {
      if (!state.activeSessionId) return null
      return state.sessions.find(s => s.id === state.activeSessionId)
    },
    isSshPanelVisible: state => state.isVisible,
  },

  mutations: {
    ADD_SSH_SESSION: (state, session) => {
      const existingIndex = state.sessions.findIndex(s => s.id === session.id)
      if (existingIndex === -1) {
        state.sessions.push(session)
      }
      state.activeSessionId = session.id
      state.isVisible = true
    },
    REMOVE_SSH_SESSION: (state, sessionId) => {
      const index = state.sessions.findIndex(s => s.id === sessionId)
      if (index !== -1) {
        state.sessions.splice(index, 1)
      }
      if (state.activeSessionId === sessionId) {
        state.activeSessionId = state.sessions.length > 0 ? state.sessions[0].id : null
      }
      if (state.sessions.length === 0) {
        state.isVisible = false
      }
    },
    SET_ACTIVE_SSH_SESSION: (state, sessionId) => {
      state.activeSessionId = sessionId
    },
    SET_SSH_PANEL_VISIBILITY: (state, isVisible) => {
      state.isVisible = isVisible
    },
    UPDATE_SSH_PANEL_STATE: (state, panelState) => {
      state.panelState = { ...state.panelState, ...panelState }
    },
    CLEAR_ALL_SSH_SESSIONS: (state) => {
      state.sessions = []
      state.activeSessionId = null
      state.isVisible = false
      state.panelState = {
        height: 440,
        isMinimized: false,
        isFullscreen: false
      }
    }
  },

  actions: {
    OpenSSHSession(context, { deviceId, deviceName, projectId }) {
      const sessionId = `${projectId}-${deviceId}`
      const session = {
        id: sessionId,
        deviceId,
        deviceName,
        projectId,
        createdAt: Date.now()
      }
      context.commit('ADD_SSH_SESSION', session)
    },
    CloseSSHSession(context, sessionId) {
      context.commit('REMOVE_SSH_SESSION', sessionId)
    },
    SetActiveSSHSession(context, sessionId) {
      context.commit('SET_ACTIVE_SSH_SESSION', sessionId)
    },
    ToggleSSHPanel(context, isVisible) {
      context.commit('SET_SSH_PANEL_VISIBILITY', isVisible)
    },
    UpdateSSHPanelState(context, panelState) {
      context.commit('UPDATE_SSH_PANEL_STATE', panelState)
    },
    CloseAllSSHSessions(context) {
      context.commit('CLEAR_ALL_SSH_SESSIONS')
    }
  }
}

export default sshSessions

